import styled from 'styled-components';
import themeHelper from '../../utils/themeHelper';

export const BREAKPOINT = 992;

export const PlayerAndPlaylist = styled.section`
  display: flex;
  gap: ${themeHelper.spacing(0.5)};
  height: calc(100vh - ${themeHelper.spacing(2)});
  width: 100%;
  ${({ $hasColumnLayout }) =>
    !$hasColumnLayout && `flex-direction: column; max-height: inherit;`}
`;
export const PlaylistContainer = styled.section`
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  max-height: inherit;
  overflow: auto;
  position: relative;
  width: ${({ $hasColumnLayout }) => ($hasColumnLayout ? '34%' : '100%')};
  > ol {
    position: ${({ $hasColumnLayout }) =>
      $hasColumnLayout ? 'absolute' : 'relative'};
    width: ${({ $hasColumnLayout }) => ($hasColumnLayout ? '34%' : '100%')};
  }
`;
export const VideoContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${themeHelper.spacing(0.5)};
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  max-height: fit-content;
  ${({ $hasColumnLayout }) =>
    !$hasColumnLayout && `flex-shrink: 0; order: -1;`};
  padding: ${themeHelper.spacing(0.5)};
  width: ${({ $hasColumnLayout }) => ($hasColumnLayout ? '66%' : '100%')};
`;
